module.exports = __webpack_public_path__ + "static/media/ecosentino-white.8c7ae5c7.svg";